/* eslint-disable import/no-unresolved */
import { arrayOf, bool, func, shape, string } from "prop-types";
import React, { Component } from "react";
import Col from "react-bootstrap/lib/Col";
import { connect } from "react-redux";
import { actions as debinActions, selectors as debinSelectors } from "reducers/debin";

import CardContainer from "pages/_components/Card/CardContainer";
import Container from "pages/_components/Container";
import I18n from "pages/_components/I18n";
import Image from "pages/_components/Image";
import Pagination from "pages/_components/pagination/Pagination";
import Spinner from "pages/_components/Spinner";
import InfiniteScroll from "react-infinite-scroll-component";
import { isUxDashboardImprovementsEnabled } from "util/v3ShellLayoutSync";
import { V3_SCROLL_ROOT_ID } from "v3/constants";
import IncomingDebinItem from "./IncomingDebinItem";

const tableLabel = "payments.debin.table.header";
class IncomingDebinTable extends Component {
    static propTypes = {
        requests: arrayOf(shape({})).isRequired,
        isDesktop: bool.isRequired,
        dispatch: func.isRequired,
        debinObject: shape({}).isRequired,
        filtersIncomingDebins: shape({
            dateFrom: shape({}).isRequired,
            dateTo: shape({}).isRequired,
            status: string.isRequired,
            recipient: string.isRequired,
        }).isRequired,
    };

    static defaultProps = {};

    componentDidMount() {
        window.scrollTo(0, 1);
    }

    fetchMoreTransactions = (pageNumber) => {
        const { dispatch, filtersIncomingDebins, isDesktop } = this.props;
        const { status, dateFrom, dateTo, recipient } = filtersIncomingDebins;

        dispatch(
            debinActions.loadIncomingRequests(
                {
                    status,
                    dateFrom,
                    dateTo,
                    seller: recipient,
                    pageNumber: pageNumber || filtersIncomingDebins.pageNumber + 1,
                },
                !isDesktop,
            ),
        );
    };

    render() {
        const { requests, isDesktop, debinObject, filtersIncomingDebins } = this.props;

        const list = requests?.debinList?.map((request) => {
            if (isDesktop) {
                return (
                    <>
                        <CardContainer className="w-100 mb-0 mt-0" key={request.id}>
                            <IncomingDebinItem
                                key={`transaction-${request.id}`}
                                request={request}
                                isDesktop={isDesktop}
                                idTransaction={request?.idTransaction}
                                link={`/payments/payDebin/detail/${request.id}`}
                            />
                        </CardContainer>
                    </>
                );
            }

            return (
                <CardContainer className="px-3">
                    <IncomingDebinItem
                        key={`transaction-${request.id}`}
                        request={request}
                        isDesktop={isDesktop}
                        tableLabel={tableLabel}
                        link={`/payments/payDebin/detail/${request.id}`}
                    />
                </CardContainer>
            );
        });

        const renderTable = isDesktop ? (
            <>
                {list}
                <div className="d-flex w-100 justify-content-end mr-3 mt-3">
                    <Pagination
                        totalPages={debinObject.totalPages}
                        pageNumber={filtersIncomingDebins.pageNumber}
                        action={this.fetchMoreTransactions}
                    />
                </div>
            </>
        ) : (
            <div className="container-fluid">
                <InfiniteScroll
                    dataLength={requests?.debinList?.length}
                    next={this.fetchMoreTransactions}
                    hasMore={debinObject.totalPages > filtersIncomingDebins.pageNumber}
                    loader={<Spinner />}
                    style={{ overflow: "hidden" }}
                    scrollableTarget={isUxDashboardImprovementsEnabled() ? V3_SCROLL_ROOT_ID : undefined}
                    endMessage={
                        <div className="table-row table-end" key="noMoreTransactions">
                            <I18n id="transactions.list.noMoreTransactions" />
                        </div>
                    }>
                    {list}
                </InfiniteScroll>
            </div>
        );

        return (
            <Container className="flex-grow overflow-visible">
                <Col md={12} className="px-0">
                    <div
                        style={{
                            borderSpacing: "0px 2px",
                            width: "100%",
                            minWidth: requests.length && isDesktop && "1170px",
                        }}
                        ref={(tableRef) => {
                            this.child = tableRef;
                        }}>
                        {requests?.debinList?.length ? (
                            renderTable
                        ) : (
                            <div className="text-center no-more-data" key="noMoreMovements">
                                <div className="illustration-wrapper">
                                    <Image src="images/coloredIcons/find-in-page.svg" className="svg-big-icon" />
                                </div>
                                <p className="text-lead">
                                    <I18n id="payments.debin.table.empty.message" />
                                </p>
                            </div>
                        )}
                    </div>
                </Col>
            </Container>
        );
    }
}

const mapStateToProps = (state) => ({
    requests: debinSelectors.getSentRequests(state),
    debinObject: debinSelectors.getDebinObject(state),
    filtersIncomingDebins: debinSelectors.getFiltersIncomingDebins(state),
});

export default connect(mapStateToProps)(IncomingDebinTable);
